import './ShrinePlaneStyle.scss';
import {fileManager} from '../Constants';
import {Link, useNavigate, useParams} from "react-router-dom";
import axiosServise from '../ApiService';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import {Fab, IconButton, Modal, Typography} from "@mui/material";
import {FavoriteBorder, OpenInNew, ThumbDown, ThumbUp, DateRange, Add, Save} from "@mui/icons-material";
import parse from "html-react-parser";
import p1 from "../../assets/icons/p1.png";
import PrettyBox from "../PrettyBox/PrettyBox.tsx";
import IranSanse from "../Typography/IranSanse.tsx";

// import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
//
// // import {CKEditor, CKEditorContext} from '@ckeditor/ckeditor5-react';
import CKEditor from 'react-ckeditor-component';
import {useEffect, useState} from "react";
// import { ClassicEditor } from '@ckeditor/ckeditor5-editor-classic';
import Cookies from 'js-cookie';
import NewsList from "../NewsList/NewsList.tsx";
import TopMenu from "../TopMenu/TopMenu.tsx";


export default function ShrineNews() {
    let data;
    let cok;

    const onChange = (evt) => {
        // console.log("onChange fired with event info: ", evt);
        data = evt.editor.getData();
        console.log(data);
    }
    // const editorConfiguration = {
    //     plugins: [ Essentials, Bold, Italic, Paragraph ],
    //     toolbar: [ 'bold', 'italic' ]
    // };
    const config = {
        language: "fa",
        fontFamily: {
            options: [
                'default',
                'Ubuntu, Arial, sans-serif',
                'Ubuntu Mono, Courier New, Courier, monospace'
            ]
        },
    };
    // const [data, setData] = useState('');

    const {newsType} = useParams();
    const [newses, setNewses] = useState([]);
    const [userType, setUserType] = useState('Admin');
    const [totalCountNews, setTotalCountNews] = useState();
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [page, setPage] = useState(1);
    const [isLoading, setIsLoading] = useState(false);
    const nav = useNavigate();
    let menus =
        [
            {
                "id": "5f8a3530-dff1-4801-8723-bed5d0b74dcf",
                "title": "اخبار حرم",
                "link": "/News/Shrine",
                "iconId": "b1220df5-5aff-42b8-a78f-38f22394e818",
                "parentId": null,
                "order": "2",
                "isActive": true
            },
            {
                "id": "98cbfe71-6392-40a5-adf1-b26399c6a32b",
                "title": "برنامه های حرم",
                "link": "/News/Plans",
                "iconId": "14a4a732-b872-433e-ab51-bb175bf9f70f",
                "parentId": null,
                "order": "3",
                "isActive": true
            },
            {
                "id": "66592871-ef5c-435e-92cb-11620e2ce122",
                "title": "اخبار خدام",
                "link": "/News/Noun",
                "iconId": p1,
                "parentId": null,
                "order": "4",
                "isActive": true
            },
            {
                "id": "cd8ca639-55a3-4519-926a-aa61f572ad31",
                "title": "اخبار شهرستان",
                "link": "/News/CityNews",
                "iconId": "e050c2e4-9e10-48cd-b09e-37ff08a3040e",
                "parentId": null,
                "order": "5",
                "isActive": true
            },
            {
                "id": "1a15e2ce-00d7-4ebc-b426-c14882175792",
                "title": "اخبار بسیج آستانه",
                "link": "/News/BasijNews",
                "iconId": "f64ec396-3b7b-4086-bf9d-de918d799910",
                "parentId": null,
                "order": "6",
                "isActive": true
            }
        ]
    useEffect(() => {
        console.log(newsType);

        getNews();
        // window.addEventListener('scroll', handleScroll);
        // return () => window.removeEventListener('scroll', handleScroll);
    }, [rowsPerPage, page, totalCountNews, newsType]) // when page index or pageSize changed -> this component will be rerender and getNews() will call again!
    const [current, setCurrent] = useState(localStorage.getItem('CurrentNewsType'))
    const [open, setOpen] = useState(false);

    const handleClose = () => {
        setOpen(false);
    };

    const handleOpen = () => {
        setOpen(true);
    };
    const getNews = () => {
        try {
            if (newsType) {
                console.log(newsType);

                localStorage.setItem('CurrentNewsType', newsType)
            }
            setCurrent(localStorage.getItem('CurrentNewsType'))
            console.log(current);

            if (current === 'Shrine') {

            } else if (current === 'Plans') {

            } else if (current === 'BasijNews') {

            } else if (current === 'CityNews') {

            } else if (current === 'Noun') {

            } else {
                localStorage.setItem('CurrentNewsType', 'Shrine')
            }
        } catch (err) {
            console.log(err);
        }
    }


    return <div>
        <Row className='g-0'>
            <Col className='px-1'>
                <TopMenu Menus={menus} OnSelected={(menu) =>{
                    nav(menu.link)
                }}/>
            </Col>
        </Row>
        <Row>
            <NewsList current={current}></NewsList>
        </Row>
    </div>
}
